<template>
  <div class="min-h-screen-safe bg-slate-900 font-sans text-slate-200 flex flex-col">
    
    <header class="flex-none sticky top-0 z-50 bg-[#0B1021]/95 backdrop-blur-md border-b border-slate-800 pt-safe flex flex-col shadow-lg">
      <div class="px-3 py-3 flex items-center justify-between relative">
        
        <NuxtLink :to="localePath('/')" class="flex items-center gap-1 text-slate-400 hover:text-white transition-colors group p-1 z-10">
          <svg class="w-6 h-6 transform group-hover:-translate-x-1 transition-transform duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
          </svg>
          <span class="text-[14px] font-bold tracking-wider">{{ locale === 'zh' ? '返回首页' : 'Home' }}</span>
        </NuxtLink>

        <h1 class="absolute left-1/2 -translate-x-1/2 font-bold text-[15px] sm:text-[16px] text-white tracking-widest uppercase pointer-events-none w-max">
          {{ locale === 'zh' ? '隐私政策' : 'Privacy Policy' }}
        </h1>

        <div class="w-16"></div>
      </div>
    </header>

    <main class="flex-auto max-w-4xl mx-auto w-full p-6 pb-safe">
      <PrivacyZh v-if="locale === 'zh'" />
      <PrivacyEn v-else />

      <div class="h-12"></div>
    </main>

  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { locale } = useI18n()

// 🚀 引入路径智能转换引擎
const localePath = useLocalePath()

// 🚀 注入富含马票/万字关键词的安全信任 SEO 矩阵
const seoData = computed(() => {
  const isZh = locale.value === 'zh'
  return {
    title: isZh 
      ? '隐私政策 (Privacy Policy) | 马新最快 4D 万字与马票开奖平台 - Lottobox' 
      : 'Privacy Policy | Fastest Malaysia & Singapore 4D Results - Lottobox',
    description: isZh
      ? 'Lottobox Live 隐私政策说明。我们不收集任何个人身份信息，为您提供纯净、安全、无广告的 4D 万字与马票开奖及现场摇珠直播查询服务。'
      : 'Privacy Policy for Lottobox Live. We collect no personal data, ensuring a pure, secure, and ad-free experience for checking 4D results and live draws.',
    keywords: '隐私政策, Privacy Policy, Lottobox, 万字, 马票, 4D results, 查万字, 数据安全, 纯净无广告'
  }
})

useHead(() => ({
  title: seoData.value.title,
  meta: [
    { name: 'description', content: seoData.value.description },
    { name: 'keywords', content: seoData.value.keywords }
  ]
}))
</script>
